import React, { useEffect, useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../store/hooks';
import { queryParams } from "../../../helpers/UrlHelpers";
import { fetchBundles } from "../../../actions/callrecorder/bundlesActions";
import { setNewParams } from "../../../store/callrecorder/bundlesSlice";
import callrecorderUrls from "../../../configs/callrecorder/callrecorderUrls";

import PageLayout from '../_partials/PageLayout';
import Edit from "./Edit";
import New from "./New";
import ListTable from "./_partials/_ListTable";
import PageHeader from "../../../componets/PageHeader";
import Wrapper from "../../../componets/Wrapper";
import Filter from "../../../componets/Filter";
import './style.scss';
import NavBarThree from "../../../componets/NavBarThree";
import { PlusOutlined, FlagOutlined } from "@ant-design/icons";

const LIMIT = 42;
const DEFAULT_ORDER_BY = 'prod_env';

const NAV_ITEMS: {[index: number]: any} = {
  1: { id: 1, name: 'Production',  url: callrecorderUrls.bundlesPath({ order_by: DEFAULT_ORDER_BY, prod_env: 'true' }) },
  2: { id: 2, name: 'Development', url: callrecorderUrls.bundlesPath({ order_by: DEFAULT_ORDER_BY, prod_env: 'false' }) },
  3: { id: 3, name: 'Favorites',   url: callrecorderUrls.bundlesPath({ order_by: DEFAULT_ORDER_BY, favorite: 'true' }) },
};

const Bundles = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const currentPage = queryParams.getInt(searchParams,'page') || 1;
  const { pathname } = useLocation();

  const activeNavId = useMemo(() => {
    if (searchParams.get('favorite') === 'true') return 3;
    const prodEnv = searchParams.get('prod_env');
    if (prodEnv === 'true') return 1;
    if (prodEnv === 'false') return 2;
    return undefined;
  }, [searchParams]);

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit:  LIMIT,
        offset: (currentPage - 1) * LIMIT
      },
      ['term', 'order_by', 'order', 'date_from', 'date_to', 'prod_env', 'favorite'],
      { 'order_by': DEFAULT_ORDER_BY }
    );

    dispatch(fetchBundles(params));
  }, [searchParams, pathname, currentPage, dispatch]);

  function onClickCreate() {
    const params: any = { prod_env: true };
    dispatch(setNewParams(params));
  }

  return (
    <PageLayout className='v-bundles'>
      <PageHeader
        title='Bundles'
        navs={NAV_ITEMS}
        activeId={activeNavId}
        parent={{
          name: 'All',
          url: callrecorderUrls.bundlesPath({ order_by: DEFAULT_ORDER_BY })
        }}
      />

      <Wrapper>
        <NavBarThree>
          <NavBarThree.Button className='v-link2' onClick={onClickCreate}>
            <PlusOutlined /> Create Bundle
          </NavBarThree.Button>
          <NavBarThree.Link className='v-link2' to={callrecorderUrls.featureFlagsPath()}>
            <FlagOutlined /> Manage Feature Flags
          </NavBarThree.Link>
        </NavBarThree>
      </Wrapper>

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            search
            dateRange
            orderBy={{
              defaultKey: DEFAULT_ORDER_BY,
              items: [
                { name: 'Date', key: 'id' },
                { name: 'Environment', key: 'prod_env' },
                { name: 'Name', key: 'name' },
              ]
            }}
          />
        </Wrapper>

        <ListTable limit={LIMIT} />
      </div>

      <New />
      <Edit />
    </PageLayout>
  );
}

export default Bundles;
